import { Skeleton, TextField, TextFieldProps, styled } from "@mui/material";
import { colours } from "../StyleConstants";
import React from "react";
const StyledTextField = styled(TextField)({
    background: colours.core.white,
    boxShadow: "1px 2px 5px 0px rgba(21, 24, 24, 0.10)",
    borderRadius: "8px",
    "& fieldset": { border: 'none' },
    "& .MuiInputBase-root": { height: "100%" },
    "& .MuiInputBase-root.Mui-disabled": { backgroundColor: colours.gray.gray10 },
    // multiline content starts near the top of the box, right where the shrunk label sits,
    // so it needs extra clearance to avoid the label overlapping the first line of text
    "& .MuiInputBase-multiline": { paddingTop: "22px" },
})
StyledTextField.defaultProps = {
    ...StyledTextField.defaultProps,
    size: "small",
    FormHelperTextProps: {
        sx: { position: "absolute", bottom: '0', transform: "translate(8px, 20px)", margin: 0 }
    },
}

type LassoTextFieldProps = {
    isLoading?: boolean,
    readonly?: boolean,
    textBox?: boolean,

} & TextFieldProps

const SINGLE_LINE_LABEL_SX = { top: '-0.8rem', transform: "translate(8px, -10px) scale(0.75)" };
const MULTILINE_LABEL_SX = { top: '0.3rem', left: 0, transform: "translate(8px, -6px) scale(0.75)" };

export const LassoTextField = React.forwardRef(function LassoTextField(props: LassoTextFieldProps, ref) {
    return <StyledTextField
        {...props}
        InputLabelProps={props.InputLabelProps ?? {
            shrink: true,
            sx: props.multiline ? MULTILINE_LABEL_SX : SINGLE_LINE_LABEL_SX,
        }}
        inputRef={ref}
        InputProps={props.InputProps ? props.InputProps : {
            readOnly: props.readonly,
            startAdornment: props.isLoading ? (
                <Skeleton width={"100%"} />
            ) : null,
        }}
    />
})